import React from 'react';
import { ToggleButton } from '.';

export { AutoRefreshToogle }

function AutoRefreshToogle({action}) {

    const handleToggleAutoRefresh = (value) => {
        if (action){
            action(value)
        }
    };

    const refreshStatus = [
        {
            "name": "ACTIVÉ",
            "value": true
        },
        {
            "name": "DESACTIVÉ",
            "value": false
        }
    ]

    return (
        <ToggleButton data={refreshStatus} setValue={handleToggleAutoRefresh} defaultValue={false}/>
    );
};

